<template>
  <div>
    <BModal
      id="modal-forgot-pin"
      ref="modal-forgot-pin"
      no-close-on-backdrop
      hide-footer
      modal-class="modal-primary"
      centered
      hide-header
    >
      <BRow class="justify-end">
        <img
          src="@/assets/images/svg/close-circle.svg"
          alt="Komerce"
          style="margin-right: 10px"
          class="cursor-pointer"
          @click="$bvModal.hide('modal-forgot-pin')"
        >
      </BRow>
      <BCol class="d-flex justify-content-center mt-2">
        <h4 class="text-black font-semibold">
          Lupa PIN
        </h4>
      </BCol>

      <BCol class="d-flex justify-content-center mt-1">
        <h5 class="text-black font-semibold">
          Pilih Metode Verifikasi
        </h5>
      </BCol>

      <BCol class="d-flex justify-content-center mb-2 text-center">
        <small
          class="text-secondary"
          style="max-width: 260px"
        >
          Pilih salah satu metode dibawah ini untuk mendapatkan kode verifikasi
        </small>
      </BCol>

      <BRow class="d-flex justify-content-center px-2 pb-2">
        <BCol
          cols="12"
          class="d-flex justify-content-center"
        >
          <div class="w-100">
            <BButton
              block
              variant="outline-primary"
              class="d-flex align-items-center p-1 method-card"
              :disabled="loadingSubmit"
              @click="requestOtpEmail"
            >
              <feather-icon
                icon="MailIcon"
                size="28"
                class="text-primary mr-1"
              />
              <div class="text-left flex-grow-1">
                <span class="font-bold d-block text-black">Email ke</span>
                <small class="text-muted">{{ maskedEmail }}</small>
              </div>
              <b-spinner
                v-if="loadingSubmit"
                small
                variant="primary"
              />
            </BButton>
          </div>
        </BCol>
      </BRow>
    </BModal>
    <ModalForgotPinByEmail
      ref="modalForgotEmail"
      :initial-token="rawToken"
      :next-request-time="nextRequestAt"
      @onSuccess="handleSuccess"
    />
  </div>
</template>

<script>
import ToastificationContentVue from '@/@core/components/toastification/ToastificationContent.vue'
import provider from '@/provider/provider'
import { REQUEST_OTP_EMAIL, SMS_OTP } from '@/provider/url'
import { newAxiosIns } from '@/libs/axios'
import {
  BCol, BButton, BModal, BRow, BSpinner, VBModal,
} from 'bootstrap-vue'
import { maskEmail } from '@/libs/helpers'
import ModalForgotPinByEmail from './ModalForgotPinByEmail.vue'

export default {
  name: 'ModalForgotPin',
  components: {
    ModalForgotPinByEmail,
    BCol,
    BButton,
    BModal,
    BRow,
    BSpinner,
  },
  directives: {
    'b-modal': VBModal,
  },
  data() {
    return {
      emailUser: this?.$store?.state?.auth?.userData?.email,
      loadingSubmit: false,
      rawToken: '',
      nextRequestAt: '',
    }
  },
  computed: {
    maskedEmail() {
      return maskEmail(this.emailUser)
    },
  },
  methods: {
    async requestOtpEmail() {
      this.loadingSubmit = true
      try {
        const response = await newAxiosIns.post(REQUEST_OTP_EMAIL, {
          purpose: 'pin',
        })
        const { data } = response.data
        this.rawToken = data.token
        this.nextRequestAt = data.next_request_at
        this.$bvModal.hide('modal-forgot-pin')
        this.$refs.modalForgotEmail.openModalOtp({
          token: data.token,
          nextRequestAt: data.next_request_at,
        })
      } catch (err) {
        const message = err.response?.data?.message || 'Gagal mengirim OTP ke email'
        this.$toast({
          component: ToastificationContentVue,
          props: {
            title: 'Gagal',
            icon: 'AlertCircleIcon',
            text: message,
            variant: 'danger',
          },
        })
      } finally {
        this.loadingSubmit = false
      }
    },
    handleSuccess() {
      // Refresh browser saat sukses
      window.location.reload()
    },
  },
}
</script>

<style lang="scss">
.method-card {
  background: #fff !important;
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
  border-radius: 8px;

  &:hover {
    border-color: #f95031 !important;
    background: #fff !important;
  }
}
</style>
